import {
  UserProfile,
  UserSecurity,
  UserSessions,
  WorkOsWidgets,
} from "@workos-inc/widgets";

import { Badge } from "@/components/ui/badge";
import { Card } from "@/components/ui/card";
import { useGetWidgetTokenQuery } from "@/data/queries";
import { SessionRoleLabels } from "@/data/types";
import useStore from "@/state";

export const Account = () => {
  const { session } = useStore();
  const { data: widgetAuth } = useGetWidgetTokenQuery([]);

  if (!session) {
    return null;
  }

  return (
    <div>
      <div className="flex justify-between border-b pb-2">
        <h2 className="scroll-m-20 text-3xl font-medium tracking-tight first:mt-0">
          Account
        </h2>
      </div>
      <div className="my-4">
        <p className="text-sm text-muted-foreground">
          View details of your account and profile.
        </p>
      </div>
      <WorkOsWidgets>
        <div className="space-y-4 my-4">
          {widgetAuth && <UserProfile authToken={widgetAuth?.token} />}
          {widgetAuth && <UserSecurity authToken={widgetAuth.token} />}
          {widgetAuth && (
            <UserSessions
              authToken={widgetAuth.token}
              currentSessionId={session.session_id}
            />
          )}

          <Card className="p-4 space-y-4">
            <div>
              <p className="text-xs text-muted-foreground">Role</p>
              <p className="text-sm font-medium">
                {SessionRoleLabels[session.role]}
              </p>
            </div>
            <div>
              <p className="text-xs text-muted-foreground">Permissions</p>
              <div className="flex flex-wrap gap-1 mt-1">
                {session.permissions.map((permission) => (
                  <Badge
                    key={permission}
                    variant="secondary"
                    className="rounded-full"
                  >
                    {permission}
                  </Badge>
                ))}
              </div>
            </div>
          </Card>
        </div>
      </WorkOsWidgets>
    </div>
  );
};
